import { createSelector, createSlice } from '@reduxjs/toolkit';

const initialState = {
    isLoading: false,
    pricingList: [],
    filterDropdownData: [],
    page: 0,
    rowsPerPage: 25
};

const slice = createSlice({
    name: 'pricing',
    initialState,
    reducers: {
        setPage(state, action) {
            state.page = action.payload;
        },
        setRowsPerPage(state, action) {
            state.rowsPerPage = action.payload;
        },
        startAllPricingList(state, action) {
            state.isLoading = true;
        },
        setPricingListData(state, action) {
            state.pricingList = action.payload;
        },
        startFetchFilterDropdown(state, action) {
            state.isLoading = true;
        },
        setFilterDropdownData(state, action) {
            state.filterDropdownData = action.payload;
        },
        completedFetch(state, action) {
            state.isLoading = false;
        }
    }
});

export const {
    startAllPricingList,
    setPricingListData,
    startFetchFilterDropdown,
    setFilterDropdownData,
    completedFetch,
    setPage,
    setRowsPerPage
} = slice.actions;
export default slice.reducer;

const pricingStates = (state) => state.pricing;

export const isLoadingSelector = createSelector([pricingStates], (pricingDataState) => pricingDataState.isLoading);
export const pricingListDataSelector = createSelector([pricingStates], (pricingDataState) => pricingDataState.pricingList);
export const filterListDataSelector = createSelector([pricingStates], (filterDataState) => filterDataState.filterDropdownData);
export const pageSelector = createSelector([pricingStates], (pricingDataState) => pricingDataState.page);
export const rowsPerPageSelector = createSelector([pricingStates], (pricingDataState) => pricingDataState.rowsPerPage);
